var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.5C1 3.83696 1.23178 3.20107 1.64437 2.73223C2.05694 2.26339 2.61652 2 3.2 2H20.8C21.3835 2 21.9431 2.26339 22.3556 2.73223C22.7682 3.20107 23 3.83696 23 4.5V19.5C23 20.163 22.7682 20.7989 22.3556 21.2678C21.9431 21.7366 21.3835 22 20.8 22H3.2C2.61652 22 2.05694 21.7366 1.64437 21.2678C1.23178 20.7989 1 20.163 1 19.5V4.5ZM4.8709 4.5L12 11.5887L19.1291 4.5H4.8709ZM20.8 6.16125L12.7249 14.1912C12.5243 14.391 12.2667 14.5011 12 14.5011C11.7333 14.5011 11.4757 14.391 11.2751 14.1912L3.2 6.16125V19.5H20.8V6.16125Z",
    fill: "#616161",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiEmail);
export default __webpack_public_path__ + "static/media/mi_email.3af849d25da4f116f4f5bbb0ba5cd74d.svg";
export { ForwardRef as ReactComponent };